export const multiSelectTagStyle = (isDarkMode: boolean) => ({
  control: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: isDarkMode ? '#262A2F' : '#fff', // Dark mode or light mode background
    borderColor: state.isFocused
      ? isDarkMode
        ? '#fff' // White border on focus in dark mode
        : '#b0c4de' // Light blue border on focus in light mode
      : isDarkMode
      ? '#262A2F' // Default border color in dark mode
      : '#ddd', // Default border color in light mode
    boxShadow: state.isFocused
      ? isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)' // White shadow on focus in dark mode
        : '0 0 5px rgba(0, 0, 255, 0.2)' // Blue shadow in light mode
      : styles.boxShadow,
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      borderColor: isDarkMode ? '#fff' : '#b0c4de', // White border on hover in dark mode
      boxShadow: isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)' // White shadow on hover in dark mode
        : '0 0 5px rgba(0, 0, 255, 0.2)', // Blue shadow in light mode
    },
    outline: 'none',
  }),
  option: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: state.isFocused ? '#4bb189' : 'transparent', //  no background on selection
    color: isDarkMode ? '#ffffff' : '#000000', // Set text color based on mode
    padding: 10,
    ':hover': {
      color: '#fff',
    },
  }),
  placeholder: (styles: any) => ({
    ...styles,
    color: '#878A99', // Customize placeholder color
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: isDarkMode ? '#fff' : '#333', // White text in dark mode, dark text in light mode
  }),

  multiValue: (styles: any, { data }: any) => ({
    ...styles,
    backgroundColor: `color-mix(in srgb, ${
      data.color ? data.color : '#4bb189'
    } 15%, transparent)`,
    borderRadius: '999px',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 6px',
    marginRight: '4px',
    // whiteSpace: 'nowrap', // ✅ Keeps items inline
    // flexShrink: 0, // ✅ Prevents squeezing when overflowed
  }),

  multiValueLabel: (styles: any, { data }: any) => ({
    ...styles,
    color: data.color ? data.color : '#4bb189',
    padding: 0,
    fontSize: '0.75rem',
    fontWeight: 500,
    marginRight: '4px',
  }),

  multiValueRemove: (styles: any, { data }: any) => ({
    ...styles,
    color: data.color ? data.color : '#4bb189',
    paddingLeft: '4px',
    paddingRight: '4px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'transparent',
      color: '#000',
    },
  }),

  clearIndicator: (styles: any) => ({
    ...styles,
    color: '#888',
    cursor: 'pointer',
    ':hover': {
      color: 'red',
      // backgroundColor: 'rgba(255, 0, 0, 0.1)',
    },
  }),
  input: (styles: any) => ({
    ...styles,
    color: isDarkMode ? '#ffffff' : '#000000', // Set search input text color
  }),
});
